<template>
  <div v-if="loaded" class="pb1">
    <div v-if="!Object.keys(order).length" class="danger darken-4 p3 mt3 mx3 white">
      {{ getReferencelabel('ORDER_LOAD_FAILED') }}
    </div>
    <div v-else class="m3 white-bg border rounded">
      <div class="p3 gap2 flex flex-column">
        <h2 class="h4n bold m0 text-center dark-blue">{{ getReferencelabel('MY_ORDER') }}</h2>
        <div>
          <h3 v-if="order.productName" class="h5n bold m0 text-center dark-blue">{{ order.productName }}</h3>
          <p v-if="order.creationDate" class="h6n m0 text-center">{{ getReferencelabel('ORDER_DATE') }} : {{ order.creationDate }}</p>
          <p v-if="order.bookingNumber" class="h6n m0 text-center">{{ getReferencelabel('ORDER_NUMBER') }} : {{ order.bookingNumber }}</p>
        </div>
        <div v-if="order.price">
          <p class="h6n m0 text-center">{{ getReferencelabel('PAYMENT_SUMMARY') }}</p>
          <p class="h6n m0 text-center">Total: {{ order.price }} € TTC</p>
        </div>
      </div>
    </div>
    <div v-if="order.payment_info" class="flex flex-column m3 p3 white-bg gap2">
      <h2 class="h4n bold m0 mb2 text-center dark-blue">{{ getReferencelabel('MY_INVOICES') }}</h2>
      <div class="py2 col-12 grey-bg" v-if="!order.payment_info.future_payments.length">
        <p class="h6n m0 text-center">{{ getReferencelabel('ALL_INVOICES_PAID') }}</p>
      </div>
      <div v-if="invoice">
        <h2 class="h4n bold m0 dark-blue my2">{{ getReferencelabel('MY_PAID_INVOICES') }}</h2>
        <div class="flex items-center col-12 justify-between" :key="invoice.reference">
          <ul class="gap1 flex flex-column">
            <li v-for="payment in order.payment_info.done_payments" :key="payment.date">
              <p class="h6n m0"> {{ getReferencelabel('INVOICE_OF') }} {{ payment.date }}: {{ payment.amount }} €</p>
            </li>
          </ul>
          <a class="px2 py1 red-bg h6n white border-none rounded" :href="download(order.bookingNumber, order.customerId, invoice.reference, invoice.type)">{{getReferencelabel('DOWNLOAD_INVOICE') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { getOrder } from '@/mixins/requests';
import { getReferencelabel } from '@/mixins/utils';

export default {
  setup(props, { emit }) {
    const route = useRoute();
    const store = useStore();

    const loaded = ref(false);
    const order = ref({});

    const invoice = computed(() => {
      return order.value.documents.find(document => document.type === "Confirmation d'inscription");
    })

    async function syncOrder() {
      store.commit('setLoading', true);

      emit('orderDetailsLoaded', loaded.value);

      order.value = await getOrder(route.params.uuid);

      loaded.value = true;

      emit('orderDetailsLoaded', loaded.value);

      store.commit('setLoading', false);
    }

    onMounted(async () => {
      await syncOrder();
    });

    function download(bookingNumber, customerId, reference, type) {
        let url = `/espacepersonnel/api/download?system_booking_number=${bookingNumber}&system_customer_id=${customerId}&reference=${reference}&modele=${type}`;

        if (store.state.impersonateData) {
          url = `${url}&impersonateData=${encodeURI(store.state.impersonateData)}`;
        }

        return url;
    }

    return {
      order,
      loaded,
      getReferencelabel,
      invoice,
      download
    };
  },
};
</script>

<style>
.input-height {
  height: 50px;
}

@media (max-width: 40em) {
  .my-profile-text {
    text-align: center;
  }
}

.bank-details {
  font-family: DINWeb, sans-serif;
  font-size: 0.75rem;
}
</style>
